<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let href: string;
  export let count: number;
  export let label: string;

  const dispatcher = createEventDispatcher<{ navigate: void }>();
</script>

<a {href} class="underline-static underline-hover text-base font-medium" on:click="{() => dispatcher('navigate')}">
  {label}
  •
  {count}
</a>

<style lang="scss">
  .underline-static:is(.dark *)::after {
    background-color: #fff;
    opacity: 0.25;
  }
</style>
